import React, { useRef } from 'react';
import { getInlineMarkDown } from '../utils';
import { ReactComponent as InfoIcon } from '../../../assets/info-circle.svg';
import '../../../stylesheets/triagebot/InfoButton.scss';

const InfoButton = ({ type, onShowInfo, header, text, ariaText, explication, disabled,isOpenCdo }) => {
    type = type || 'info';
    text = text || '';
    ariaText = ariaText || '';

    const buttonRef = useRef(null);

    const lastIndex = text.lastIndexOf(" ");
    const firstWords = text.substring(0, lastIndex);
    const lastWord = text.substring(lastIndex);

    if (typeof onShowInfo !== 'function')
        onShowInfo = () => { };

    const showInfoDialog = () => {
        onShowInfo({
            type: type,
            header: header,
            body: explication,
            triggerElement: buttonRef.current
        })
    }

    const normalizeLabelText = (value) => {
        return String(value || '')
            .replace(/[\[\]()*_`#>]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const associatedText = normalizeLabelText(ariaText) || normalizeLabelText(text) || normalizeLabelText(lastWord);
    const headerText = normalizeLabelText(header);

    const infoButtonLabel =
        (associatedText.length > 0)
            ? `More information for ${associatedText}`
            : (headerText.length > 0
                ? `More information for: ${headerText}`
                : 'More information');

    return (
        <span className='info-text'>
            {text.trim().length > 0 && getInlineMarkDown(firstWords + '&#32;')}

            <span className='nowrap'>
                {text.trim().length > 0 && getInlineMarkDown(lastWord)}
                {
                    <button
                        ref={buttonRef}
                        type='button'
                        className={`${type} ${isOpenCdo ? 'open-summary' : ''}`}
                        disabled={disabled}
                        aria-label={infoButtonLabel}
                        title={infoButtonLabel}
                        onClick={showInfoDialog}
                    >
                        <InfoIcon aria-hidden='true' focusable='false' />
                    </button>
                }
            </span>
        </span>
    )
}

export default InfoButton;